// extracted by mini-css-extract-plugin
module.exports = {"text":"OverflowText_text__3J2BP","oneLiner":"OverflowText_oneLiner__3Vi_u","tooltip":"OverflowText_tooltip__2B79R"};